"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchGlobalSaga = void 0;
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const global_1 = require("@/app/shared/store/global");
const reduxUtils_1 = require("@/app/shared/store/reduxUtils");
const actions_1 = require("@/app/SUMO/store/user/actions");
const actions_2 = require("@/app/SUMOCEP/store/user/actions");
const effects_1 = require("redux-saga/effects");
const actions_3 = require("./actions");
const selectors_1 = require("./selectors");
function* initializeApp(action) {
    if (action.type !== actions_3.GlobalActionTypes.INITIALIZE_APP)
        return;
    try {
        const savedServerType = yield (0, effects_1.call)(helpers_1.Storage.Local.get, helpers_1.Storage.Key.SERVER_TYPE);
        const savedServerEnvironment = yield (0, effects_1.call)(helpers_1.Storage.Local.get, helpers_1.Storage.Key.SERVER_ENVIRONMENT);
        const savedServerUrl = yield (0, effects_1.call)(helpers_1.Storage.Local.get, helpers_1.Storage.Key.SERVER_SALESFORCE_INSTANCE_URL);
        const savedServerPrefix = yield (0, effects_1.call)(helpers_1.Storage.Local.get, helpers_1.Storage.Key.SERVER_PREFIX);
        const savedDefaultHost = yield (0, effects_1.call)(helpers_1.Storage.Local.get, helpers_1.Storage.Key.DEFAULT_HOST);
        const storageServerType = yield (0, effects_1.select)(selectors_1.globalSelectors.selectServerType);
        const storageServerEnvironment = yield (0, effects_1.select)(selectors_1.globalSelectors.selectServerEnvironment);
        const storageServerUrl = yield (0, effects_1.select)(selectors_1.globalSelectors.selectServerUrl);
        const storageServerPrefix = yield (0, effects_1.select)(selectors_1.globalSelectors.selectServerPrefix);
        const storageDefaultHost = yield (0, effects_1.select)(selectors_1.globalSelectors.selectDefaultHost);
        const isNewServerType = savedServerType !== undefined && savedServerType !== storageServerType;
        const isNewServerEnvironment = savedServerEnvironment !== undefined && savedServerEnvironment !== storageServerEnvironment;
        const isNewServerUrl = savedServerUrl !== undefined && savedServerUrl !== storageServerUrl;
        const isNewServerPrefix = savedServerPrefix !== undefined && savedServerPrefix !== storageServerPrefix;
        const isNewDefaultHost = savedDefaultHost !== undefined && savedDefaultHost !== storageDefaultHost;
        if (isNewServerType)
            yield (0, effects_1.put)(global_1.globalActions.setServerType(savedServerType));
        if (isNewServerEnvironment)
            yield (0, effects_1.put)(global_1.globalActions.setServerEnvironment(savedServerEnvironment));
        if (isNewServerUrl)
            yield (0, effects_1.put)(global_1.globalActions.setServerUrl(savedServerUrl));
        if (isNewServerPrefix)
            yield (0, effects_1.put)(global_1.globalActions.setServerPrefix(savedServerPrefix));
        if (isNewDefaultHost)
            yield (0, effects_1.put)(global_1.globalActions.setDefaultHost(savedDefaultHost));
        const serverType = yield (0, effects_1.select)(selectors_1.globalSelectors.selectServerType);
        if (serverType === "SUMO" /* ServerType.SUMO */)
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.initializeUser());
        if (serverType === "SALESFORCE" /* ServerType.SALESFORCE */)
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.initializeUser());
    }
    catch (error) {
        yield (0, effects_1.put)(actions_1.SUMO1UserActions.getAuthenticationFail());
        yield (0, effects_1.put)(global_1.globalActions.handleLogout());
        yield (0, effects_1.call)(reduxUtils_1.handleServiceError, error, constants_1.TOAST_ERROR_ID.GET_MAIN_DATA_ERROR_MESSAGE);
    }
}
function* handleLogout(action) {
    if (action.type !== actions_3.GlobalActionTypes.HANDLE_LOGOUT)
        return;
    try {
        const serverType = yield (0, effects_1.select)(selectors_1.globalSelectors.selectServerType);
        if (serverType === "SUMO" /* ServerType.SUMO */) {
            yield (0, effects_1.put)(actions_1.SUMO1UserActions.handleLogout());
        }
        else {
            yield (0, effects_1.put)(actions_2.SUMOCEPUserActions.handleLogout());
        }
    }
    catch (error) {
        console.error('Logout failed:', error);
    }
}
function* watchGlobalSaga() {
    yield (0, effects_1.takeLatest)(actions_3.GlobalActionTypes.INITIALIZE_APP, initializeApp);
    yield (0, effects_1.takeLatest)(actions_3.GlobalActionTypes.HANDLE_LOGOUT, handleLogout);
}
exports.watchGlobalSaga = watchGlobalSaga;
